export default __webpack_public_path__ + "static/media/logo-beta.21776d02.svg";